<div class="text-center">
  <h1 class="h4">Identity Verification</h1>
  <div class="lead">
    @if (isVerified()) {
      Your account has been verified! Click the button below to continue to the educator portal.
    }
    @if (!isVerified()) {
      We weren't able to find an educator record with the details that you provided. Please
      <a href="#" (click)="onTryAgain($event)">try again</a> or contact ADE for assistance.
    }
  </div>
</div>
<div class="verified-icon mx-auto d-flex justify-content-center">
  @if (isVerified()) {
    <i class="bi bi-check-circle text-success"></i>
  }
  @if (!isVerified()) {
    <i class="bi bi-x-circle text-danger"></i>
  }
</div>
<div class="d-grid">
  <button class="btn btn-primary mx-2" (click)="onContinue()">Continue</button>
</div>
